import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogActions, 
  Button, 
  Box, 
  Typography, 
  Grid, 
  Grow,
  Paper
} from '@mui/material';

// Import relevant icons from Material-UI
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import AllInboxOutlinedIcon from '@mui/icons-material/AllInboxOutlined';
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';


const HelpModule = ({ open, handleClose }) => {
  const tips = [
    {
      icon: <PlayCircleOutlineIcon sx={{ fontSize: 32, color: 'primary.main' }} />,
      title: "Just Start Talking",
      description: "There's no right or wrong way to begin. Speak your mind freely and let the conversation flow naturally."
    },
    {
      icon: <QuestionAnswerOutlinedIcon sx={{ fontSize: 32, color: 'primary.main' }} />,
      title: "Follow the Flow",
      description: "ZOSA will provide gentle cues and questions to guide you. Engage with them to explore your thoughts more deeply."
    },
    {
      icon: <LightbulbOutlinedIcon sx={{ fontSize: 32, color: 'primary.main' }} />,
      title: "Discover Insights",
      description: "Pay attention to the patterns and reflections ZOSA offers. These moments are opportunities for self-discovery."
    },
    {
      icon: <AllInboxOutlinedIcon sx={{ fontSize: 32, color: 'primary.main' }} />,
      title: "Save & Revisit",
      description: "When you're done, end and save your session. Your encrypted conversations are there for you to reflect on later."
    }
  ];

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" PaperProps={{ sx: { borderRadius: '16px' } }}>
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Box textAlign="center" mb={4}>
          <PsychologyAltIcon sx={{ fontSize: 60, color: 'primary.main', mb: 1 }} />
          <Typography variant="h4" component="h1" gutterBottom fontWeight={600}>
            How to Begin with ZOSA
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '600px', margin: '0 auto' }}>
            ZOSA is here to listen. Here are a few tips to help you get the most out of your session.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {tips.map((tip, index) => (
            <Grid item xs={12} sm={6} key={tip.title}>
              <Grow in={open} timeout={(index + 1) * 300}>
                <Box sx={{ textAlign: 'left', p: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {tip.icon}
                    <Typography variant="h6" component="h3" fontWeight={500}>
                      {tip.title}
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1, pl: '48px' /* Aligns text under title */ }}>
                    {tip.description}
                  </Typography>
                </Box>
              </Grow>
            </Grid>
          ))}
        </Grid>
        
        <Grow in={open} timeout={1500}>
            <Paper 
                variant="outlined" 
                sx={{ 
                    mt: 4, 
                    p: 2, 
                    textAlign: 'center', 
                    borderColor: 'primary.light', 
                    background: (theme) => theme.palette.mode === 'dark' ? 'rgba(93, 135, 255, 0.1)' : 'rgba(93, 135, 255, 0.05)',
                    borderRadius: '12px'
                }}
            >
                <Typography variant="subtitle1" fontWeight={500} component="div">
                    Pro-Tip
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Still not sure where to start? Try sharing how your day has been!
                </Typography>
            </Paper>
        </Grow>

      </DialogContent>
      <DialogActions sx={{ p: { xs: 2, sm: 3 }, pt: 0 }}>
        <Button 
          onClick={handleClose} 
          variant="contained" 
          size="large" 
          sx={{ minWidth: '150px', borderRadius: '8px' }}
        >
          Got It!
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HelpModule;